import React from "react"
import Layout from "../components/layout"
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import StyledBackgroundSection from "../components/background"

const GalleryPage = () => (
  <Layout>
            <h1>Gratulerer med dagen Martine !!</h1>
     <div>
      <Breadcrumb tag="nav" listTag="div">
        <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
        <BreadcrumbItem tag="a" href="/gallery">Gallery</BreadcrumbItem>
        <BreadcrumbItem tag="a" href="#">Wishes</BreadcrumbItem>
        <BreadcrumbItem tag="a" href="/presents">Surprise</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <StyledBackgroundSection/>
 
  </Layout>
)


export default GalleryPage
